import ErrorScreen from 'pages/errorScreen';
import React, { useEffect, useState } from 'react';

const ErrorBoundary = ({ children }: any) => {
    const [hasError, setHasError] = useState<any>();
    const [error, setError] = useState<number | null | any>(null);

    useEffect(() => {
        const errorHandler = (err: any) => {
            setHasError(true);
            const errorData = {
                name: err.name,
                message: err.message,
                stack: err.stack
                // Include any other properties you want to capture
            };

            // Convert the extracted data to JSON
            const serializedError = JSON.stringify(errorData);

            setError(serializedError);
        };

        // Attach the error handler to the global error event
        window.addEventListener('error', errorHandler);

        return () => {
            // Clean up the event listener when the component unmounts
            window.removeEventListener('error', errorHandler);
        };
    }, []); // Empty dependency array ensures the effect runs only once

    if (hasError) {
        // Fallback UI for errors
        return <ErrorScreen showHeader={true} err={error} />;
    }
    return <>{children}</>;
};

export default ErrorBoundary;
